import { Segmented, Space, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const viewMode = z.enum(['single', 'diff']);

type ViewMode = z.infer<typeof viewMode>;

type Props = {
  defaultViewMode: ViewMode;
  onChange: (nextViewMode: ViewMode) => void;
};

export const SingleAndDiffViewModeSwitcher: FC<Props> = ({
  defaultViewMode,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Space>
      <Text
        text={t('view-mode')}
        weight="regular"
        style={{ whiteSpace: 'nowrap' }}
      />
      <Segmented
        options={[
          {
            label: t('view-mode-single'),
            value: viewMode.Values.single,
          },
          { label: t('view-mode-diff'), value: viewMode.Values.diff },
        ]}
        defaultValue={defaultViewMode}
        onChange={onChange}
      />
    </Space>
  );
};
